import * as React from 'react';
import {fetchUtils, Form, required, TextInput, useNotify} from 'react-admin';
import {ADMIN_AUTH_URL} from "../../constants/api-url";
import {useFormContext} from "react-hook-form";
import {ErrorResponse} from "../../types/errors-response";
import {errorsExtractor} from "../../utils/errors-extractor";

const API_AUTH = ADMIN_AUTH_URL;

type ForgotValues = { email: string };

const SubmitButton = () => {
  const notify = useNotify();
  const {setError,getValues, formState: {isValid, isLoading, isSubmitted}} = useFormContext<ForgotValues>();

  const onSubmit = async () => {
    const { email } = getValues();
    try {
      await fetchUtils.fetchJson(`${API_AUTH}/forgot-password`, {
        method: 'POST',
        body: JSON.stringify({ email }),
        headers: new Headers({ 'Content-Type': 'application/json' }),
      });
      notify('If that email exists, a code has been sent.', { type: 'info' });
      window.location.hash = `/reset-password?email=${encodeURIComponent(email)}`;
    } catch (e: any) {
      const body: ErrorResponse | undefined = e?.body;
      if (!body) {
        notify('Something went wrong');
        return
      }
      if (body && 'details' in body) {
        errorsExtractor(body as ErrorResponse, setError)
        return;
      }
      notify(body.message || ('message' in e ? e.message as string : JSON.stringify(e)), {type: 'warning'});
    }
  };

  return (
    <div style={{ marginTop: 16 }}>
      <button type="button" disabled={(!isValid && isSubmitted) || isLoading} onClick={onSubmit} style={{ width: '100%', padding: 10 }}>
        Send code
      </button>
    </div>
  )
}

export default function ForgotPassword() {
  return (
    <div style={{ maxWidth: 420, margin: '10vh auto' }}>
      <h2 style={{ marginBottom: 16 }}>Forgot Password</h2>
      <Form defaultValues={{ email: '' }} noValidate>
        <TextInput source="email" type="email" label="Email" fullWidth validate={[required()]} />
        <SubmitButton/>
      </Form>
    </div>
  );
}
